import SideBarContainer, { Divider } from 'DesignSystem/features/sidebar';

import CardActivities from './card-activity';
import CardSideBarDetails from './details';

export default function CardSideBar() {
  return (
    <>
      <SideBarContainer>
        <CardSideBarDetails />
        <Divider />
        <CardActivities />
      </SideBarContainer>
    </>
  );
}
